import Drawer from '@mui/material/Drawer';

interface FavoritesDrawerProps {
  open: boolean;
  onClose: () => void;
}

const FavoritesDrawer = ({ open, onClose }: FavoritesDrawerProps) => (
  <Drawer anchor="right" open={open} onClose={onClose}>
    Favorites/Saved Searches go here
  </Drawer>
);

export default FavoritesDrawer;
